/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-cycle
import Checkbox from '../children/Checkbox';
import Select from '../children/Select';
import Radio from '../children/Radio';
import Label from '../children/Label';
import ListBox from '../children/Listbox';
import Slider from '../children/Slider';
import PlusMinus from '../children/PlusMinus';
import SearchList from '../children/SearchList';
import InputField from '../children/InputField';
import { ControlType } from '../index';

const SwitchComponent = ({ control, component }: { control?: ControlType; component: any }) => {
  switch (control) {
    case ControlType.SLIDER:
      return Slider;
    case ControlType.EXTERNAL:
      return component;
    case ControlType.CHECKBOX:
      return Checkbox;
    case ControlType.RADIO:
      return Radio;
    case ControlType.SELECT:
      return Select;
    case ControlType.LISTBOX:
      return ListBox;
    case ControlType.SEARCH_LIST:
      return SearchList;
    case ControlType.PLUSMINUS:
      return PlusMinus;
    case ControlType.INPUT:
      return InputField;
    case ControlType.LABEL:
    default:
      return Label;
  }
};

export default SwitchComponent;
